"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    width: 'auto',
    minWidth: 'auto',
    display: 'inline-block',
    // only for calculation of default divider height
    fontSize: palette.tsNormal,
    lineHeight: 1.5,
    labelColor: palette.tLabel,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    labelTransitionFunction: palette.transitionFunction,
    labelTransitionDuration: palette.transitionDuration,
    labelPaddingRight: '0',
    labelPaddingLeft: '0',
    labelOverflow: 'visible',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    fontFamily: palette.fontFamily,
    idleLabelColor: palette.tLabel,
    idleBorderColor: palette.elDivider,
    idleBorderStyle: 'none none solid',
    idleBorderTransform: 'scale(0)',
    idleBorderWidth: '1px',
    idleBorderRadius: '0',
    idleBackground: 'transparent',
    idleBoxShadow: 'none',
    focusLabelColor: palette.tAccent,
    focusBorderColor: palette.elAccent,
    focusBorderStyle: 'none none solid',
    focusBorderTransform: 'scaleX(1)',
    focusBorderWidth: '2px',
    focusBorderRadius: '0',
    focusBackground: 'transparent',
    focusBoxShadow: 'none',
    hoverLabelColor: palette.tLabel,
    hoverBorderColor: palette.elSecondary,
    hoverBorderStyle: 'none none solid',
    hoverBorderTransform: 'scaleX(1)',
    hoverBorderWidth: '2px',
    hoverBorderRadius: '0',
    hoverBackground: 'transparent',
    hoverBoxShadow: 'none',
    disabledLabelColor: palette.tLabel,
    disabledBorderTransform: 'scaleX(1)',
    disabledBorderStyle: 'none none dotted',
    disabledBorderColor: palette.elDivider,
    disabledBorderWidth: '2px',
    disabledBorderRadius: '0',
    disabledBackground: 'transparent',
    disabledBoxShadow: 'none',
    errorLabelColor: palette.tError,
    errorBorderColor: palette.elError,
    errorBorderStyle: 'none none solid',
    errorBorderTransform: 'scaleX(1)',
    errorBorderWidth: '2px',
    errorBorderRadius: '0',
    errorBackground: 'transparent',
    errorBoxShadow: 'none'
  };
}